import { AnyEventObject } from "xstate";
import { AppContext } from "../../typings";

const searchByPNR = async (
  _context: AppContext,
  event: AnyEventObject,
): Promise<string | Error> => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const body = JSON.stringify({ ...event });

  const options = {
    method: "POST",
    headers: headers,
    body,
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/search-by-pnr`,
      options,
    ).then((r) => r.json());

    if (typeof response.data === "object") {
      return response.data;
    }

    throw response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

export default searchByPNR;
